<div class="indicator-content">
  <div class="indicator-header">
    <span class="indicator-title"> <b>Top 10:</b> Classe Terapêutica </span>
    <div fxLayoutAlign="end center">
      <indicator-filter (filterDataEvent)="onFilterData($event)"></indicator-filter>
    </div>
  </div>
  <div *ngIf="isLoading" class="loader-container">
    <indicator-loader></indicator-loader>
  </div>
  <div *ngIf="!isLoading" class="indicator-content-container">
    <div class="indicator-total">Total: {{ getTotal() }}</div>
    <div class="table-grid table-header">
      <span>Classe Terapêutica</span>
      <span>Quantidade</span>
      <span class="grid-rank">Ranking(%)</span>
    </div>
    <div *ngFor="let indicatorItem of getTopTenTherapeuticClassList(); trackBy: trackByFn" class="table-grid table-body">
      <!-- column 1 -->
      <div class="column-1">
        <img src="./assets/icons/product-icon.svg" />
        <span [matTooltip]="indicatorItem.indicatorItemName">{{ indicatorItem.indicatorItemName }}</span>
      </div>
      <!-- column 2 -->
      <div class="column-2">
        <span>{{ indicatorItem.indicatorItemQuantity }}</span>
      </div>
      <!-- column 3 -->
      <div class="column-3">
        <div class="progressive-bar" [style.width.%]="indicatorItem.indicatorItemPercentage"></div>
        <span>{{ indicatorItem.indicatorItemPercentage }}%</span>
      </div>
    </div>
    <div *ngIf="!hasTopTenTherapeuticClassData()" class="no-results">
      <p>Não foram encontrados resultados.</p>
    </div>
  </div>
</div>
